module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAAQCAYAAAD0xERiAAABIUlEQVQ4jZ3TTyuEURTH8c9Ms7LCC/AC5iUo1hbGC/ASUApJIqUspCiLWUzZ2FjYCAvZKMQspwhlMSulNELSxPizmGfq6Wlmnmf86nbu/Z1zv91z66RypeIGvnGIc9QkVwYDGMZPBnlcYRrPOMJ+EF+bALoxhJEg9qCKbAb3WMMCejEarC+c4gCX6EcOg8GLwlpFOZUrFaELt+jroMWGysiimg6MD8z8AwRT6m1Kh8xdnHQIOsZe45COJCfU/yqJPjEZNqKwG2wmhK3jrh0MlvEYA3rAStRsBnvDXAxsFu9JYLCNixa5M+w0S7SC/WJcfczCqmEsyCeGQQmFiJfHdasL7WCwiEqwf8JSu+I4WCUAwjxe2hVHB7aZCuqztxVX+Adbkj7x0lswygAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/images/portal/select-arrow.png
// module id = 417
// module chunks = 10